// extracted by mini-css-extract-plugin
export default {"planCard1":"plan_cards_planCard1__3158h","planCard2":"plan_cards_planCard2__8TdrY","planCardsParents":"plan_cards_planCardsParents__zOJEz"};